import React from 'react';
import { FaEdit, FaSpinner } from 'react-icons/fa';
import { RELATIONSHIP_OPTIONS } from '../constants';

export function EditProxyModal({ 
  show, 
  editingProxy, 
  editProxyForm, 
  setEditProxyForm, 
  savingProxy, 
  onSave, 
  onClose 
}) {
  if (!show || !editingProxy) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="edit-proxy-modal">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-3 bg-purple-100 rounded-full">
            <FaEdit className="text-purple-600 text-xl" />
          </div>
          <h3 className="text-2xl font-bold text-gray-800">Edit Member Info</h3>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Name *</label>
            <input
              type="text"
              value={editProxyForm.name}
              onChange={(e) => setEditProxyForm({ ...editProxyForm, name: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              placeholder="Full name"
              required
              data-testid="edit-proxy-name"
            />
          </div>
          
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Email Address
              <span className="text-sm font-normal text-gray-500 ml-2">(required for invitation)</span>
            </label>
            <input
              type="email"
              value={editProxyForm.email}
              onChange={(e) => setEditProxyForm({ ...editProxyForm, email: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              placeholder="email@example.com"
              data-testid="edit-proxy-email"
            />
            {!editProxyForm.email && (
              <p className="text-sm text-amber-600 mt-1">
                Add an email to enable invitation to create an account
              </p>
            )}
          </div>
          
          <div>
            <label className="block text-gray-700 font-medium mb-2">Relationship</label>
            <select
              value={editProxyForm.relationship}
              onChange={(e) => setEditProxyForm({ ...editProxyForm, relationship: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              data-testid="edit-proxy-relationship"
            >
              {RELATIONSHIP_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex space-x-4 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            disabled={savingProxy || !editProxyForm.name.trim()}
            className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 flex items-center justify-center space-x-2"
            data-testid="save-proxy-btn"
          >
            {savingProxy ? (
              <>
                <FaSpinner className="animate-spin" />
                <span>Saving...</span>
              </>
            ) : (
              <span>Save Changes</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
